// extracted by mini-css-extract-plugin
module.exports = {"root":"Agreement_root__lAmbl","page":"Agreement_page__3PDud","list":"Agreement_list__whVRp","button":"Agreement_button__MT_OZ","noPrint":"Agreement_noPrint__MpwaG"};